import { ability, defineAbilityFor } from "./ability";

export const initCASL = (user) => {
    ability.update(defineAbilityFor(user));
};
